module.exports = __webpack_public_path__ + "static/media/vc-wink.4b6149a2.svg";